var merge = require('webpack-merge')
var prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  env: 'development',
  apiUrl: 'http://localhost:8080/v1', // Local seulement
  healthUrl: 'http://localhost:8080/healthsecured' // Local seulement
})
